module.exports = __webpack_public_path__ + "img/1.2ac1d748.jpg";